import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Button, Card, Col, Container, Input, Label, Row, Nav, NavItem, NavLink,
  Modal, ModalBody, ModalFooter, ModalHeader, Spinner, Badge, Form
} from "reactstrap";
import classnames from "classnames";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { ToastContainer, toast } from "react-toastify";

const Bildirimler = () => {
  document.title = "Bildirim Merkezi | LojGo";

  // --- ROL VE AUTH KONTROLÜ ---
  const authUser = JSON.parse(localStorage.getItem("authUser"));
  const userId = authUser?.ID;
  const isAdmin = authUser?.Users_Type_ID === 3;

  // --- STATE YÖNETİMİ ---
  const [activeTab, setActiveTab] = useState("inbox");
  const [notifications, setNotifications] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  
  // Modal State'leri (Yeni Bildirim Gönderme)
  const [composeModal, setComposeModal] = useState(false);
  const [isSending, setIsSending] = useState(false);
  const [usersList, setUsersList] = useState([]);
  const [formData, setFormData] = useState({
    Receiver_ID: "all", // "all" = Herkese, ID = Belirli kişiye
    Title: "",
    Message: ""
  });

  const toggleComposeModal = () => setComposeModal(!composeModal);

  // --- 1. BİLDİRİMLERİ ÇEKME ---
  const fetchNotifications = async () => {
    setIsLoading(true);
    try {
      // Örnek OData: Kişiye özel VEYA herkese (Receiver_ID = 0/null) gönderilenleri çek
      // Admin ise gönderdiği veya tüm bildirimleri görebilir
      const filterStr = isAdmin ? "" : `$filter=Receiver_ID eq ${userId} or Receiver_ID eq 0&`;
      const response = await fetch(`https://hiflowapi.stechomeyazilim.info/Notifications?${filterStr}$orderby=Created_DateTime desc`);
      const result = await response.json();

      if (result && result.value) {
        setNotifications(result.value.map(item => ({
          id: item.ID,
          title: item.Title || "Sistem Bildirimi",
          message: item.Message || "",
          date: item.Created_DateTime ? new Date(item.Created_DateTime).toLocaleString('tr-TR') : "-",
          isRead: item.Is_Read || false,
          type: item.Type || "general" // general, important, system
        })));
      }
    } catch (error) {
      console.error("Bildirimler çekilemedi:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // --- 2. KULLANICI LİSTESİNİ ÇEKME (SADECE ADMİN) ---
  const fetchUsersForDropdown = async () => {
    if (isAdmin) {
      try {
        const response = await fetch("https://hiflowapi.stechomeyazilim.info/Users?$select=ID,Users_NameSurname");
        const result = await response.json();
        if (result && result.value) setUsersList(result.value);
      } catch (error) {
        console.error("Kullanıcılar yüklenemedi:", error);
      }
    }
  };

  useEffect(() => {
    fetchNotifications();
    fetchUsersForDropdown();
  }, [isAdmin]);

  // --- 3. BİLDİRİM GÖNDERME (POST) ---
  const handleSendNotification = async (e) => {
    e.preventDefault();
    setIsSending(true);

    const payload = {
      Sender_ID: userId,
      Receiver_ID: formData.Receiver_ID === "all" ? 0 : parseInt(formData.Receiver_ID),
      Title: formData.Title,
      Message: formData.Message,
      Is_Read: false,
      Created_DateTime: new Date().toISOString()
    };

    try {
      const response = await fetch("https://hiflowapi.stechomeyazilim.info/Notifications", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        toast.success("Bildirim başarıyla gönderildi!");
        toggleComposeModal();
        setFormData({ Receiver_ID: "all", Title: "", Message: "" });
        fetchNotifications(); // Listeyi yenile
      } else {
        toast.error("Gönderim başarısız oldu.");
      }
    } catch (error) {
      toast.error("Bağlantı hatası.");
    } finally {
      setIsSending(false);
    }
  };

  // Filtreleme Mantığı
  const filteredNotifications = notifications.filter(notif => {
    if (activeTab === "inbox") return true;
    if (activeTab === "unread") return !notif.isRead;
    if (activeTab === "important") return notif.type === "important";
    return true;
  });

  const unreadCount = notifications.filter(n => !n.isRead).length;

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="İletişim" breadcrumbItem="Bildirim Merkezi" />

          <Row>
            <Col xs="12">
              <Card className="email-leftbar border-0 shadow-sm">
                {/* SADECE ADMİN İSE YENİ BİLDİRİM BUTONU GÖRÜNÜR */}
                {isAdmin && (
                  <Button type="button" color="primary" className="btn-rounded waves-effect waves-light w-100 shadow-sm" onClick={toggleComposeModal}>
                    <i className="mdi mdi-plus me-1"></i> Yeni Bildirim Gönder
                  </Button>
                )}

                <div className="mail-list mt-4">
                  <Nav tabs className="nav-tabs-custom border-0" vertical role="tablist">
                    <NavItem>
                      <NavLink className={classnames({ active: activeTab === "inbox" })} onClick={() => setActiveTab("inbox")} style={{cursor: "pointer"}}>
                        <i className="mdi mdi-bell-outline me-2 align-middle"></i> Tüm Bildirimler
                        {unreadCount > 0 && <Badge color="danger" className="float-end mt-1">{unreadCount}</Badge>}
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink className={classnames({ active: activeTab === "unread" })} onClick={() => setActiveTab("unread")} style={{cursor: "pointer"}}>
                        <i className="mdi mdi-email-open-outline me-2 align-middle"></i> Okunmamışlar
                      </NavLink>
                    </NavItem>

                    <NavItem>
                      <NavLink className={classnames({ active: activeTab === "important" })} onClick={() => setActiveTab("important")} style={{cursor: "pointer"}}>
                        <i className="mdi mdi-alert-decagram-outline me-2 align-middle text-warning"></i> Önemli Duyurular
                      </NavLink>
                    </NavItem>
                  </Nav>
                </div>
              </Card>

              {/* BİLDİRİM GÖNDERME MODALI (ADMİN) */}
              <Modal isOpen={composeModal} toggle={toggleComposeModal} centered size="lg">
                <div className="modal-content border-0">
                  <ModalHeader toggle={toggleComposeModal} className="bg-primary text-white">
                    Sistem Bildirimi Gönder
                  </ModalHeader>
                  <ModalBody className="p-4">
                    <Form onSubmit={handleSendNotification}>
                      <div className="mb-4">
                        <Label className="fw-medium">Kime Gönderilecek?</Label>
                        <Input type="select" className="form-select" value={formData.Receiver_ID} onChange={(e) => setFormData({...formData, Receiver_ID: e.target.value})}>
                          <option value="all">Tüm Sistem Kullanıcılarına (Duyuru)</option>
                          <optgroup label="Bireysel Sürücüler">
                            {usersList.map(u => <option key={u.ID} value={u.ID}>{u.Users_NameSurname}</option>)}
                          </optgroup>
                        </Input>
                      </div>

                      <div className="mb-4">
                        <Label className="fw-medium">Bildirim Başlığı</Label>
                        <Input type="text" className="form-control" required placeholder="Örn: Evrak Güncellemesi Hakkında" value={formData.Title} onChange={(e) => setFormData({...formData, Title: e.target.value})} />
                      </div>
                      
                      <div className="mb-4">
                        <Label className="fw-medium">Mesaj İçeriği</Label>
                        <Input type="textarea" rows="6" required className="form-control" placeholder="Kullanıcıya iletilecek mesajınızı buraya yazın..." value={formData.Message} onChange={(e) => setFormData({...formData, Message: e.target.value})} />
                      </div>

                      <div className="d-flex justify-content-end gap-2">
                        <Button type="button" color="light" onClick={toggleComposeModal}>İptal</Button>
                        <Button type="submit" color="primary" disabled={isSending}>
                          {isSending ? <Spinner size="sm" /> : <><i className="mdi mdi-send me-1"></i> Gönder</>}
                        </Button>
                      </div>
                    </Form>
                  </ModalBody>
                </div>
              </Modal>

              {/* BİLDİRİMLER LİSTESİ */}
              <div className="email-rightbar mb-3">
                <Card className="shadow-sm border-0">
                  <div className="p-3 border-bottom d-flex align-items-center justify-content-between bg-light bg-opacity-50">
                     <h5 className="mb-0 text-dark font-size-15">
                        {activeTab === "inbox" && "Tüm Bildirimler"}
                        {activeTab === "unread" && "Okunmamış Bildirimler"}
                        {activeTab === "important" && "Önemli Duyurular"}
                     </h5>
                     <Button color="light" size="sm" onClick={fetchNotifications}><i className="mdi mdi-refresh"></i> Yenile</Button>
                  </div>
                  
                  {isLoading ? (
                    <div className="text-center py-5"><Spinner color="primary" /></div>
                  ) : filteredNotifications.length > 0 ? (
                    <ul className="message-list">
                      {filteredNotifications.map((notif) => (
                        <li key={notif.id} className={notif.isRead ? "" : "unread fw-bold bg-light bg-opacity-50"}>
                          <div className="col-mail col-mail-1">
                            <div className="checkbox-wrapper-mail">
                              <i className={`mdi ${notif.type === 'important' ? 'mdi-alert-decagram text-warning' : 'mdi-bell-ring-outline text-primary'} font-size-18 me-3`}></i>
                            </div>
                            <Link to="#" className="title text-dark">{notif.title}</Link>
                          </div>
                          <div className="col-mail col-mail-2">
                            <div className="text-muted text-truncate" style={{maxWidth: "60%"}}>
                               {notif.message}
                            </div>
                            <div className="date text-muted small">{notif.date}</div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <div className="align-items-center text-center p-5">
                      <i className="mdi mdi-bell-sleep-outline text-muted display-4 mb-3"></i>
                      <h5 className="text-muted">Görüntülenecek bildirim bulunmuyor.</h5>
                    </div>
                  )}
                </Card>
              </div>

            </Col>
          </Row>
        </Container>
      </div>
      <ToastContainer autoClose={2000} />
    </React.Fragment>
  );
};

export default Bildirimler;